export default "__VITE_ASSET__Cs3mK8Tu__"